"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDeliveryBoxProps = getDeliveryBoxProps;
var _models = require("../models");
var _dispatchUserActionEvent = require("./dispatchUserActionEvent");
/** TODO: Merge with useDeliveryItem if possible & minimize differences between flat selection UI and older variants. */
function getDeliveryBoxProps({
  activeFilter,
  deliveryItem,
  isFlatSelection,
  isRefreshPending,
  isSelectedDeliveryLoading,
  selectedItem,
  metaHierarchy,
  onDeleteAddress,
  onDeliveryItemActivation,
  onEditAddress
}) {
  const {
    addressId,
    deliveryChannelId
  } = deliveryItem;
  const key = `${addressId}_${deliveryChannelId}`;
  let onDeleteAddressClick;
  let onEditAddressClick;
  if (addressId !== undefined) {
    // Address data modifications can be done from Delivery Options dialog, addresses tab,
    // or from Home delivery section in flat selection UI.
    if (onDeleteAddress) {
      onDeleteAddressClick = event => {
        event?.preventDefault();
        event?.stopPropagation();
        // analytics
        (0, _dispatchUserActionEvent.dispatchUserActionEvent)([...metaHierarchy, _models.MetaHierarchy.DeleteAddress]);
        onDeleteAddress(addressId);
      };
    }
    if (onEditAddress) {
      onEditAddressClick = event => {
        event?.preventDefault();
        event?.stopPropagation();
        // analytics
        (0, _dispatchUserActionEvent.dispatchUserActionEvent)([...metaHierarchy, _models.MetaHierarchy.EditAddress]);
        onEditAddress(addressId);
      };
    }
  }
  const isActive = isFlatSelection ? selectedItem?.addressId === addressId : false;
  return {
    activeFilter,
    boxName: 'suggestion',
    deliveryItem,
    isActive,
    isRefreshPending,
    isSelectedDeliveryLoading,
    key,
    metaHierarchy,
    onDeleteAddressClick,
    onDeliveryItemActivation,
    onEditAddressClick
  };
}